
{
  "actions": {
    "update": "Update",
    "cancel": "Cancel"
  },
  "errors": {
    "upload": "Unable to upload image"
  }
}
